import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import generateShortId from '@/utils/generateId.js';
import ProductConfig from '../components/product-config.vue';
import deliverGroupList from './deliver-group-list.vue';
import MetaInfo from '../components/meta-info';
import demandMixin from '../create/demand-mixin';

export default {
  mixins: [demandMixin],

  components: {
    deliverGroupList: deliverGroupList,
    ProductConfig: ProductConfig,
    MetaInfo: MetaInfo
  },

  props: {
    demand: {
      type: Object,
      required: true
    },

    creationList: {
      type: Array,
      required: true
    },

    tagData: {
      type: Object,
      default: function _default() {}
    },

    updateDeliverGroupList: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      formConfig: {
        inline: false,
        labelPosition: 'top',
        labelWidth: ''
      },

      deliverGroupList: [] // 这里的数据会被跨组件修改 deliver-group-list
    };
  },


  computed: {
    formItemList: function formItemList() {
      return {
        worktime: {
          label: '工时消耗：',
          prop: 'worktime',
          params: {
            type: 'text',
            clearable: false,
            readonly: true,
            disabled: true,
            placeholder: '请输入工时消耗'
          }
        },

        estimated_time: {
          label: '预计完成日期：',
          prop: 'estimated_time',
          params: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            placeholder: '请选择预计完成日期',
            clearable: false,
            disabled: true,
            readonly: true
          }
        }
      };
    },
    isPlayable2D3D: function isPlayable2D3D() {
      var _this = this;

      var list = [2, 3];
      var sign = list.some(function (val) {
        return Number(_this.data.category_id === val);
      });
      // 属于playable2d或者3d
      return sign;
    }
  },

  watch: {
    creationList: function creationList(_creationList) {
      var _this2 = this;

      // 过滤交付列表，根据渠道去重
      this.deliverGroupList = _.unionBy(_creationList, 'channel').map(function (item) {
        return [_this2.generateDeliver({
          channel: item.channel
        })];
      });
    },


    deliverGroupList: {
      handler: function handler(newList) {
        this.updateDeliverGroupList(newList);
      },

      deep: true
    }
  },

  methods: {
    /**
     * 删除交付表单组列表项
     * @param {Object} option
     * @param {number} option.deliverIndex
     * @param {number} option.groupIndex
     */
    deleteDeliver: function deleteDeliver(_ref) {
      var deliverIndex = _ref.deliverIndex,
          groupIndex = _ref.groupIndex;

      this.deliverGroupList[groupIndex].splice(deliverIndex, 1);
    },


    /**
     * 新增交付物表单，groupIndex 是渠道组别的索引
     * @param {Object} option
     * @param {number} option.groupIndex
     * @param {Object} option.deliver
     */
    addDeliver: function addDeliver(_ref2) {
      var groupIndex = _ref2.groupIndex,
          _ref2$deliver = _ref2.deliver,
          deliver = _ref2$deliver === undefined ? {} : _ref2$deliver;

      var newDeliver = _extends({}, this.generateDeliver({
        channel: this.deliverGroupList[groupIndex][0].channel
      }), deliver);
      this.deliverGroupList[groupIndex].push(newDeliver);
    },


    /**
     * 更新交付表单组列表项
     * @param {Object} option
     * @param {number} option.deliverIndex
     * @param {number} option.groupIndex
     * @param {Object} option.deliver
     */
    updateDeliver: function updateDeliver(_ref3) {
      var deliverIndex = _ref3.deliverIndex,
          groupIndex = _ref3.groupIndex,
          deliver = _ref3.deliver;

      var newDeliver = _extends({}, this.deliverGroupList[groupIndex][deliverIndex], deliver);
      this.deliverGroupList[groupIndex].splice(deliverIndex, 1, newDeliver);
    },


    /**
     * 生成交付物表单数据
     * @param {{}} deliver
     */
    generateDeliver: function generateDeliver(deliver) {
      var getDefaultDeliver = function getDefaultDeliver() {
        return {
          name: '', // 创意名字
          file_name: '',
          url: '', // S3 链接，用作预览
          path: '', // 服务器临时链接，提交表单时用
          channel: '', // 渠道 id
          tag_ids: [], // 标签列表
          id: '',
          _id: generateShortId() // id
        };
      };
      return _extends({}, getDefaultDeliver(), deliver);
    }
  }
};